import * as React from 'react'

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import EditIcon from '@material-ui/icons/Edit'
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn'
import FileDownloadIcon from '@material-ui/icons/FileDownload'
import AddIcon from '@material-ui/icons/Add'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { isAdmin } from '../../project-utils/permissions'
import { ActionButton, Back, PermissionGuard } from '../atoms'
import { DownloadExport } from '../organisms'
import { post } from '../../config'
import { FormattedMessage } from 'react-intl'
import getBase64 from '../../utils/base64'
const renderDownloadButton = ({ loaded }) => {
  return (
    <>
      <Hidden xsDown>
        <ActionButton
          disabled={!loaded}
          color={'primary'}
          actionType={'download'}
          variant={'raised'}
        />
      </Hidden>
      <Hidden smUp>
        <Button
          disabled={!loaded}
          color={'primary'}
          variant={'raised'}
        >
          <FileDownloadIcon />
        </Button>
      </Hidden>
    </>
  )
}

interface ProgramBarProps {
  companiesFetching?: boolean
  onAddClick?: () => void
  exportRequest?: any
  programId: any
  onFinishClick?: (values:any) => void
}

interface MyState {
  isOpen: boolean
  isOpenConfirm: boolean
}

class ProgramBar extends React.Component<ProgramBarProps, MyState> {
  public inputRef
  constructor(props) {
    super(props)
    this.inputRef = React.createRef();
    this.state = {
      isOpen: false,
      isOpenConfirm: false
    }
  }
  onButtonClick = () => {
    this.inputRef.current.click()

  }
  getFileName = () => {
    let fileName = ''
    for (let file of this.inputRef.current.files) {
      if (file) {
        fileName = file.name
      }
    }
    return fileName
  }

  getBase64FromFile = availableTo => () => {
    for (let file of this.inputRef.current.files) {
      if (file) {
        getBase64(file, this.uploadFile(availableTo))
      }
    }
  }

  uploadFile = availableTo => base64 => {
    post('/admin/upload', {
      base64,
      programId: parseInt(this.props.programId),
      fileName: this.getFileName(),
      availableTo: availableTo
    })
      .then(data => this.handleClose())
      .then(data => this.handleOpenConfirm())
      .catch(err => {
        console.error(err);
        this.handleClose()
      })
  }

  handleClickOpen = () => {
    this.setState({
      isOpen: true
    })
  }
  handleOpenConfirm = () => {
    this.setState({
      isOpenConfirm: true
    })
  }

  handleClose = () => {
    this.setState({
      isOpen: false
    })
  }

  handleCloseConfirm = () => {
    this.setState({
      isOpenConfirm: false
    })
  }

  showFinsihButon = (finish) => {
    if(finish != undefined){
      return (<Grid item>
        <Hidden xsDown>
          <ActionButton
            onClick={finish}
            actionType={'finish'}
            color={'primary'}
            variant={'raised'}
          />
        </Hidden>
        <Hidden smUp>
          <Button
            onClick={finish}
            color={'primary'}
            variant={'raised'}
          >
            <AssignmentTurnedIn />
          </Button>
        </Hidden>
      </Grid>)
    }
    else{
      return false
    }
  }

  render() {
    const {
      onAddClick,
      exportRequest,
      onFinishClick
    } = this.props
    const { isOpen, isOpenConfirm } = this.state

    return (
      <Grid
        container
        justify={'space-between'}
        alignItems={'center'}
        spacing={24}
      >
        <Grid item>
          <Back />
        </Grid>
        <PermissionGuard check={isAdmin}>
          <Grid item>
            <Grid container spacing={16}>
              <Grid item>
                <Hidden xsDown>
                  <ActionButton
                    color={'secondary'}
                    onClick={this.onButtonClick}
                    actionType={'up'}
                    variant={'raised'}
                  >
                    <input
                      type='file'
                      id="file"
                      ref={this.inputRef}
                      style={{ display: 'none' }}
                      onChange={this.handleClickOpen}
                    />
                  </ActionButton>
                </Hidden>
                <Hidden smUp>
                  <Button
                    color={'secondary'}
                    variant={'raised'}
                  >
                    <input
                      type='file'
                      id="file"
                      ref={this.inputRef}
                      style={{ display: 'none' }}
                      onChange={this.handleClickOpen}
                    />
                    <AddIcon />
                  </Button>
                </Hidden>
                {
                  isOpen && this.inputRef.current.files[0] !== undefined &&
                  <Dialog
                    open={isOpen}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        <FormattedMessage id={'dialog.text'} />
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleClose}>
                        <FormattedMessage id={'buttonActions.cancel'} />
                      </Button>
                      <Button onClick={this.getBase64FromFile('mentor')} color="primary" autoFocus>
                        <FormattedMessage id={'button.continue.mentor'} />
                      </Button>
                      <Button onClick={this.getBase64FromFile('mentee')} color="primary" autoFocus>
                        <FormattedMessage id={'button.continue.mentee'} />
                      </Button>
                      <Button onClick={this.getBase64FromFile('all')} color="primary" autoFocus>
                        <FormattedMessage id={'button.continue.all'} />
                      </Button>
                    </DialogActions>
                  </Dialog>
                }
                {
                  isOpenConfirm &&
                  <Dialog
                    open={isOpenConfirm}
                    onClose={this.handleCloseConfirm}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        <FormattedMessage id={'dialog.OK'} />
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleCloseConfirm}>
                        <FormattedMessage id={'buttonActions.close'} />
                      </Button>
                    </DialogActions>
                  </Dialog>
                }
              </Grid>
              <Grid item>
                <DownloadExport
                  fileName={'processes.xlsx'}
                  fileRequest={exportRequest}
                >
                  {renderDownloadButton}
                </DownloadExport>
              </Grid>
              <Grid item>
                <Hidden xsDown>
                  <ActionButton
                    onClick={onAddClick}
                    actionType={'edit'}
                    color={'primary'}
                    variant={'raised'}
                  />
                </Hidden>
                <Hidden smUp>
                  <Button
                    onClick={onAddClick}
                    color={'primary'}
                    variant={'raised'}
                  >
                    <EditIcon />
                  </Button>
                </Hidden>
              </Grid>
              {this.showFinsihButon(onFinishClick)}
              
            </Grid>
          </Grid>
        </PermissionGuard>
      </Grid>
    )
  }
}

export default ProgramBar



// WEBPACK FOOTER //
// ./src/components/molecules/ProgramBar.tsx